module.exports = __webpack_public_path__ + "static/media/wg-logo.1ec342e7.png";